/**
 * Helper para abrir el chat de soporte (Zendesk Messaging) con un mensaje inicial.
 *
 * Todos los call sites deberían usar `openSupportPrefill` en lugar de llamar
 * directamente a `Intercom.showNewMessage`, con las siguientes excepciones que
 * siguen usando Intercom por decisión de producto:
 *   - CreditCardCreatorStripe / MercadoPago / PagoUno (tarjetas)
 *   - plan/views/item.js: talkToUs y openHelpChatMPSubscription
 */

type IntegrationsLike = {
  zendesk?: {
    openWithPrefill?: (message: string) => boolean;
    startConversation?: () => boolean;
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getIntegrations = (): IntegrationsLike | undefined =>
  (window as unknown as { app?: { integrations?: IntegrationsLike } }).app?.integrations;

export const openSupportPrefill = (message: string): void => {
  const zendesk = getIntegrations()?.zendesk;
  if (!zendesk || typeof zendesk.openWithPrefill !== "function") {
    console.warn("[supportChat] zendesk.openWithPrefill not available");
    return;
  }
  // Mantener el binding: openWithPrefill usa `this.ready` / `this._pending` internamente.
  zendesk.openWithPrefill(message);
};

export const openSupportChat = (): void => {
  const zendesk = getIntegrations()?.zendesk;
  if (!zendesk || typeof zendesk.startConversation !== "function") {
    console.warn("[supportChat] zendesk.startConversation not available");
    return;
  }
  zendesk.startConversation();
};

export default { openSupportPrefill, openSupportChat };
